import { Component, HostListener, OnInit } from '@angular/core';
import { ThemeOptions } from '../../../theme-options';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AuthenticateService } from '../../../shared/services/authenticate.service'

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  public extraParameter: any;
  globalImgUrl: any;

  constructor(public globals: ThemeOptions, private authService: AuthenticateService, private activatedRoute: ActivatedRoute) {

  }

  @select('config') public config$: Observable<any>;

  private newInnerWidth: number;
  private innerWidth: number;
  activeId = 'dashboardsMenu';

  toggleSidebar() {
    this.globals.toggleSidebar = !this.globals.toggleSidebar;
  }

  sidebarHover() {
    setTimeout(() => {
      this.globals.sidebarHover = !this.globals.sidebarHover;
    }, 1000);
  }
  ngDoCheck() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
  }
  ngOnInit() {
    this.authService.getBack.subscribe((lang: any) => {
      this.toggleSidebar()
    })
    // this.globalImgUrl = myApi.s3url;
    setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 1200) {
        this.globals.toggleSidebar = true;
      }
    });

    this.extraParameter = this.activatedRoute.snapshot.firstChild.data.extraParameter;

  }
  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  OnselectOption(heading){
    this.authService.sendHeading(heading);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.newInnerWidth = event.target.innerWidth;

    if (this.newInnerWidth < 1200) {
      this.globals.toggleSidebar = true;
    } else {
      this.globals.toggleSidebar = false;
    }

  }
}
